import Jobs from './Jobs.vue'

export default Jobs
